$(() => {
  $('#toggle-password').on('click', () => {
    const $passwordInput = $('#password-input');
    const isPassword = $passwordInput.attr('type') === 'password';
    $passwordInput.attr('type', isPassword ? 'text' : 'password');
    $('#toggle-password').toggleClass('fa-eye fa-eye-slash');
  });
});
